/* jshint esversion:6 */
/* globals ajaxLogin */
/* globals home */
/* globals forgotPassword */
/* globals ssoPolicyRegex */
/* globals googleRecaptchaScoreBasedSiteKey */
/* globals googleRecaptchaChallengeBasedSiteKey */
/* globals wafIgnoreInputs */
/* globals isRecaptchaEnabled */
/* globals isMfaTrustDeviceSystemEnabled */

import '../css/login.scss';
import '../../../../../../../system/library/password/password-policy.js';

$(document).ready(function(){
    $('#splash').hide();
    $('#password_change_dialog_form').hide();
    $('#login-button').prop('disabled', true);
    $('[data-bs-toggle="tooltip"]').tooltip();

    var position_1 = 'Sign In';
    var position_2 = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Please Wait..';
    let totalSeconds = 3 * 60;
    let timer;
    let widget;
    let widget_forgot;
    let recaptchaScoreToken = null;
    let recaptchaChallengeToken = null;
    let recaptchaHtmlElement = null;
    let recaptchaStatus = "score";
    initRecaptcha();


    function checkLogin(mfaStatus = false) {
        var email = $('#email').val() || "";
        var password = $('#password').val() || "";
        var system_type = getParameterByName('system_type');

        let mfaCode = null;
        if(mfaStatus) {
            mfaCode = getMFACode() || null;
        }

        email = email.trim(email);
        password = password.trim(password);

        if (!email || !password) {
            loginAlert('Please enter your email and password to log in');

            return false;
        } else if (mfaStatus && (mfaCode == null || mfaCode.length != 6)) {
            loginAlert("Please enter a valid MFA code.");

            return false;
        }

        var sso_company_control_text = checkSSOPolicy(email);

        if (sso_company_control_text !== '') {
            loginAlert(sso_company_control_text);
            return false;
        }

        requestLogin(email, password, system_type, mfaCode);
        if(recaptchaStatus == "score") {
            clearMFACode();
        }
    }

    function recaptchaChallengeCallback(token) {
        recaptchaChallengeToken = token || null;
    }

    async function requestLogin(email, password, system_type, mfaCode) {
        clearLoginAlert();
        toggleLoginButtons(true);
        let isRedirecting = false;

        let requestData = {
            email: email,
            password: password,
            system_type: system_type
        };


        var loginAction = "login";

        if (mfaCode) {
            requestData.mfa_code = mfaCode;
            loginAction = "mfa_login";
        }

        if(recaptchaStatus == "score"){
            recaptchaScoreToken = await getRecaptchaScoreBasedToken(loginAction);
        }else{
            requestData.recaptcha_challenge = true;
        }

        requestData.recaptcha_token = recaptchaStatus == "score" ? recaptchaScoreToken : recaptchaChallengeToken;

        if(recaptchaStatus == "challenge" && !requestData.recaptcha_token) {
            loginAlert('Please check the verification box.');
            return;
        }

        if (isMfaTrustDeviceSystemEnabled && $("#mfa-trust-checkbox").prop("checked")) {
            requestData.is_mfa_trust_device_enabled = true;
        }

        $.ajax({
            url: ajaxLogin,
            type: 'POST',
            data: requestData,
            beforeSend: function () {
                $('#login-button').html(position_2);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                const statusCode = jqXHR.status;
                const errorMessage = `Login Exception: AJAX Login Error: ${textStatus} (${statusCode})`;
                const err = new Error(errorMessage);

                window.Sentry.captureException(err, {
                    tags: {
                        area: 'ajax',
                        route: 'login'
                    },
                    extra: {
                        method: 'POST',
                        email: email,
                        responseText: jqXHR.responseText ? jqXHR.responseText.substring(0, 1000) : 'Empty Response',
                        readyState: jqXHR.readyState,
                        errorThrown: errorThrown
                    }
                });

                if(statusCode === 0 ){
                    loginAlert('Connection error. Please check your internet connection and try again.');
                    return;
                }

                if(statusCode === 403) {
                    toggleForget();
                    $('#forget-alert').html(`
                    <div class="alert alert-danger alert-dismissible fw-bold mb-4">
                        Your password needs to be updated before you can continue. Please reset your password to access your account.
                    </div>`);
                    return;
                }
            },
            success: async function (req) {
                if (req.successful) {
                    if(req.data?.mfa == true){
                        toggleForm('mfa_form');
                        recaptchaHtmlElement = 'g-recaptcha-challenge-mfa';
                        widget = await getRecaptchaScoreBasedToken(loginAction);
                        recaptchaStatus = 'score';
                        startCountdown();
                    }else if(req.data?.is_mobile){
                        isRedirecting = true;
                        let event = {
                            event: 'auth',
                            data: {
                                user_auth_token: req.data?.token,
                                recaptcha_token: '-', // mobile old version
                            },
                        };
                        sendEvent(event);
                    }else if(req.data?.redirect_url){
                        var parameters = {};
                        parameters = {
                            token: req.data?.token,
                        };
                        isRedirecting = true;
                        clearInterval(timer);
                        createAndSubmitPostForm(req.data.redirect_url, parameters, req.data?.method)
                    }else{
                        loginAlert("Something went wrong. Please try again.");
                        return false;
                    }
                } else {
                    if(req.data?.recaptcha_challenge == true && recaptchaStatus == "score"){
                        recaptchaHtmlElement = "g-recaptcha-challenge";
                        if(mfaCode){
                            recaptchaHtmlElement = "g-recaptcha-challenge-mfa";
                        }
                        widget = await renderRecaptchaChallenge(recaptchaHtmlElement, loginAction);
                        recaptchaStatus = "challenge";
                    }else if(req.data?.recaptcha_reset == true || recaptchaStatus == "challenge"){
                        if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
                            grecaptcha.enterprise.reset(widget);
                        }
                    }
                    loginAlert(req.message);
                }
                recaptchaScoreToken = null;
                recaptchaChallengeToken = null;
            },
            complete: function () {
                $('#login-button').html(position_1);
                if(!isRedirecting){
                    toggleLoginButtons(false);
                }
                clearMFACode();
            }
        });
    }

    function toggleForm(formName) {
        var forms = ['#login_form', '#mfa_form', '#password_change_dialog_form'];

        forms.forEach(function(form) {
            $(form).hide();
        });

        $('#' + formName).show();
    }


    function sendEvent(event){
        if (window.NativeJavascriptInterface) {
            window.NativeJavascriptInterface.postMessage(JSON.stringify(event));
        } else if (window.webkit && window.webkit.messageHandlers) {
            try {
                webkit.messageHandlers.NativeJavascriptInterface.postMessage(event);
            }
            catch(err) {
                console.log(err);
            }
        } else {
            console.log("No native APIs found.");
        }
    }
    function getMFACode() {
        let code = '';
        $('.mfa-input').each(function() {
            code += $(this).val();
        });
        return code;
    }

    function clearMFACode() {
        $('.mfa-input').val('');
        $('#digit1').focus();
    }

    function loginAlert(message) {
        let alert = '<div class="alert alert-danger alert-dismissible fade show" role="alert"><strong>' + message + '</strong></div>';
        $('#login-alert').html(alert);
    }

    function clearLoginAlert() {
        $('#login-alert').html('');
    }

    function toggleForget() {
        $('#forget-form').toggle();
        $('#login-form').toggle();
        $('#forget-alert').empty();

        recaptchaReset()
    }

    async function forgotPasswordSend() {
        var email = $('#forgot-email').val();
        var system_type = getParameterByName('system_type');

        let requestData = {
            email: email,
            system_type: system_type
        };

        if(recaptchaStatus == "score"){
            recaptchaScoreToken = await getRecaptchaScoreBasedToken("forgot_password");
        }else{
            requestData.recaptcha_challenge = true;
        }

        requestData.recaptcha_token = recaptchaStatus == "score" ? recaptchaScoreToken : recaptchaChallengeToken;

        if (email.length > 0) {
            $.ajax({
                url: forgotPassword,
                type: 'POST',
                data: requestData,
                success: async function (req) {
                    if (req.successful) {
                        window.Toastify({
                            text: req.message,
                            className: 'success',
                        }).showToast();
                        window.setTimeout(function () {
                            window.location.reload();
                        }, 3000);
                    }else {
                       if (req.data?.recaptcha_challenge == true){
                           widget_forgot = await renderRecaptchaChallenge("g-recaptcha-challenge-forgot", "forgot_password");
                            recaptchaStatus = "challenge";
                       }else if(req.data?.recaptcha_reset == true){
                           if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
                               grecaptcha.enterprise.reset(widget_forgot);
                           }
                       }
                        window.Toastify({
                            text: req.message,
                            className: 'error',
                        }).showToast();
                    }
                    recaptchaScoreToken = null;
                    recaptchaChallengeToken = null;
                    $('#forgot-email').val('');
                }
            });
        } else {
            window.Toastify({
                text: 'Please fill the form.',
                className: 'error',
            }).showToast();
        }
    }

    function checkSSOPolicy(string) {
        var REGEX = ssoPolicyRegex;

        var POLICY_REGEX_ARRAY = JSON.parse(REGEX);
        var error_message = '';
        POLICY_REGEX_ARRAY.forEach(function (r) {
            if (testRegex(string, r['regex_pattern_for_js'])) {
                error_message += "Please select your company to Log In with your SSO credentials.";
            }
        });

        return error_message;

    }

    document.addEventListener('keypress', function (e) {
        const passwordInput = document.querySelector('#password');
        if (passwordInput && e.target === passwordInput && e.key === 'Enter') {
            checkLogin();
        }
    });

    function getParameterByName(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name) || '';
    }

    function initRecaptcha() {
        if (!isRecaptchaEnabled) {
            $('#login-button').prop('disabled', false);
            return;
        }

        $('#login-button').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

        const start = Date.now();
        const check = setInterval(function() {
            if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
                clearInterval(check);
                grecaptcha.enterprise.ready(function() {
                    $('#login-button').html(position_1);
                    $('#login-button').prop('disabled', false);
                });
            } else if (Date.now() - start >= 10000) {
                clearInterval(check);
                $('#login-button').html(position_1);
                loginAlert('Verification could not be loaded. Please refresh the page and try again.');

                const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
                const networkInfo = connection ? {
                    effectiveType: connection.effectiveType,
                    downlink: connection.downlink,
                    rtt: connection.rtt,
                } : { effectiveType: 'unknown', downlink: 'unknown', rtt: 'unknown' };

                if (window.Sentry) {
                    window.Sentry.captureMessage('reCAPTCHA could not be loaded', {
                        level: 'warning',
                        tags: {
                            area: 'recaptcha',
                            likely_cause: window._recaptchaLoadError ? 'ad_blocker_or_network_error' : 'slow_network',
                        },
                        extra: {
                            timeoutMs: Date.now() - start,
                            scriptLoadError: window._recaptchaLoadError || false,
                            networkEffectiveType: networkInfo.effectiveType,
                            networkDownlink: networkInfo.downlink,
                            networkRtt: networkInfo.rtt,
                        }
                    });
                }
            }
        }, 250);
    }

    function getRecaptchaScoreBasedToken(type = 'login') {
        if (!isRecaptchaEnabled) return Promise.resolve(null);

        return new Promise(function(resolve, reject) {
            grecaptcha.enterprise.ready(function() {
                grecaptcha.enterprise.execute(googleRecaptchaScoreBasedSiteKey, { action: type })
                    .then(resolve)
                    .catch(function(err) {
                        console.error("reCAPTCHA hatası:", err);
                        window.Toastify({
                            text: 'Your request timed out. Please try again.',
                            className: 'Error',
                        }).showToast();
                        reject(err);
                    });
            });
        });
    }
    function renderRecaptchaChallenge(htmlElement, action = 'login') {
        if(!isRecaptchaEnabled) return null;

        return new Promise((resolve) => {
            grecaptcha.enterprise.ready(function () {
                const widget = grecaptcha.enterprise.render(htmlElement, {
                    'sitekey': googleRecaptchaChallengeBasedSiteKey,
                    'action': action,
                    'callback': recaptchaChallengeCallback,
                });

                resolve(widget);
            });
        });
    }

    function updateCountdown() {
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;

        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;

        $('#countdown').text(minutes + ':' + seconds);

        if (totalSeconds > 0) {
            totalSeconds--;
            $('.resend-button').addClass('disabled-resend-button');
        } else {
            clearInterval(timer);
            $('#countdown').text('00.00');
            $('.resend-button').removeClass('disabled-resend-button');
            $('#verified-button').attr('disabled', true);
        }
    }

    function startCountdown() {
        clearInterval(timer);
        totalSeconds = 3 * 60;
        updateCountdown();
        timer = setInterval(updateCountdown, 1000);
    }

    $('.resend-button').click(function(){
        startCountdown();
        checkLogin();
    });

    $('.mfa-input').on('keydown', function(e) {
        var currentInput = $(this);
        var prevInput = currentInput.prev('input');

        if (e.key === 'Backspace' && currentInput[0].selectionStart === 0) {
            if (prevInput.length > 0) {
                prevInput.focus();
                var val = prevInput.val();
                prevInput[0].setSelectionRange(val.length, val.length);
            }
        }
    });

    $('.mfa-input').on('input', function() {
        var currentInput = $(this);
        var nextInput = currentInput.next('input');

        this.value = this.value.replace(/\D/g, '');

        if (currentInput.val().length === 1 && nextInput.length > 0) {
            nextInput.focus();
        }
    });

    $('.mfa-input').on('paste', function(e) {
        e.preventDefault();
        var pasteData = (e.originalEvent || e).clipboardData.getData('text');

        pasteData = pasteData.replace(/\D/g, '');

        var inputs = $('.mfa-input');
        var currentIndex = inputs.index(this);

        for (var i = 0; i < pasteData.length && currentIndex + i < inputs.length; i++) {
            $(inputs[currentIndex + i]).val(pasteData[i]);
        }

        var targetIndex = Math.min(currentIndex + pasteData.length, inputs.length - 1);
        inputs.eq(targetIndex).focus();
    });



    function createAndSubmitPostForm(actionUrl, parameters = {}, method = 'POST') {
        if (method.toUpperCase() === 'GET') {
            const url = new URL(actionUrl);
            for (const key in parameters) {
                if (parameters.hasOwnProperty(key)) {
                    url.searchParams.append(key, parameters[key]);
                }
            }
            window.location.href = url.toString();
        } else {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = actionUrl;

            for (const key in parameters) {
                if (parameters.hasOwnProperty(key)) {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = parameters[key];
                    form.appendChild(input);
                }
            }

            document.body.appendChild(form);
            form.submit();
        }
    }

    function toggleLoginButtons(isDisabled) {
        const buttonLogin = $('#login-button');
        const buttonMfa = $('#verified-button');

        if (buttonLogin.length === 0 || buttonMfa.length === 0) return;

        buttonLogin.prop('disabled', isDisabled);
        buttonMfa.prop('disabled', isDisabled);
    }

    function recaptchaReset() {
        if ($('#login-form').is(':visible')) {
            if (widget === undefined) recaptchaStatus = "score";
            else recaptchaStatus = "challenge";
        }
        if ($('#forget-form').is(':visible')) {
            if (widget_forgot === undefined) recaptchaStatus = "score";
            else recaptchaStatus = "challenge";
        }

        clearLoginAlert()
        recaptchaScoreToken = null;
        recaptchaChallengeToken = null;
    }

    window.checkLogin = checkLogin;
    window.requestLogin = requestLogin;
    window.loginAlert = loginAlert;
    window.toggleForget = toggleForget;
    window.forgotPasswordSend = forgotPasswordSend;
    window.checkSSOPolicy = checkSSOPolicy;
    window.updateCountdown = updateCountdown;
    window.getMFACode = getMFACode;
    window.clearMFACode = clearMFACode;
    window.sendEvent = sendEvent;
})